import palmLineTypesList from './actions/palmLineTypesList';
import getPalmLineTypes from './getters/getPalmLineTypes';
import palmLineTypesUpload from './mutations/palmLineTypesUpload';

const actions = {
    palmLineTypesList
};

const mutations = {
    palmLineTypesUpload
};

const getters = {
    getPalmLineTypes
};

export default { actions, mutations, getters };
